import { render, staticRenderFns } from "./dangJianShe.vue?vue&type=template&id=0786a304&scoped=true"
import script from "./dangJianShe.vue?vue&type=script&lang=js"
export * from "./dangJianShe.vue?vue&type=script&lang=js"
import style0 from "./dangJianShe.vue?vue&type=style&index=0&id=0786a304&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0786a304",
  null
  
)

export default component.exports